<template>
    <div>
        <md-button class="back-btn" @click="rollupTreeChart()" :disabled="backBtnDisabled">Go back</md-button>
        <div ref="treeChart" class="dashboard-tree-chart"></div>
    </div>
</template>
<script>
import loadGoogleCharts from "./GoogleChartLoader";
import {
    getIndicatorKeys,
    getIndicatorNames,
} from "@/components/Dashboard/StrataDashboardHelperFunctions";

export default {
    name: "DashboardTreeChart",
    data: () => ({
        google: null,
        chart: null,
        timeoutToResize: null,
        selection: [],
    }),
    props: {
        regionalData: {
            type: Object,
            required: true,
        },
        districtualData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        backBtnDisabled(){
            if (this.selection.length == 0) {
                return true;
            }
            if (this.selection[0].column == null && this.selection[0].row == 0){
                return true;
            }
            return false;
        }
    },
    mounted() {
        loadGoogleCharts("current", { packages: ["treemap"] }).then(
            (google) => {
                this.google = google;
                this.loadChart();
            }
        );
    },
    methods: {
        loadChart() {
            let chartData = this.loadData(
                this.regionalData,
                this.districtualData
            );
            chartData = this.google.visualization.arrayToDataTable(chartData);
            this.chartData = chartData;

            this.chartOptions = { // For v50+
                enableHighlight: true,
                maxDepth: 1,
                maxPostDepth: 2,
                minColor: "#8acb9d",
                midColor: "#fff34b",
                maxColor: "#d81d3f",
                headerHeight: 15,
                showScale: true,
                useWeightedAverageForAggregation: true,
                generateTooltip: showFullTooltip,
                textStyle: {
                    color: "black",
                    fontName: "Montserrat",
                    fontSize: 14,
                    bold: true,
                    italic: false
                }
            };

            // can also take a param value which is the colour row
            function showFullTooltip(row, size) {
                return `
                <div style="background:#fd9; padding:10px; border-style:solid">
                    <span>
                        <b>${chartData.getValue(row, 0)}</b>
                        <br />
                        Strata Score: ${size.toFixed(2)}
                        <br />
                        Left-click to see sub-regions
                        <br />
                        Right-click to see parent regions
                    </span>
                </div>
                `;
            }

            new ResizeObserver(this.drawChart).observe(this.$refs.treeChart);
        },
        drawChart() {
            // debounce function
            clearTimeout(this.timeoutToResize);
            this.timeoutToResize = setTimeout(() => {
                console.log("resizing tree chart")
                var tree = new this.google.visualization.TreeMap(this.$refs.treeChart);
                this.chart = tree;
                tree.draw(this.chartData, this.chartOptions);

                this.$emit('tree-chart', this.chart);

                // listen for select events on the chart
                this.google.visualization.events.addListener(this.chart, 'select', () => {
                    this.selection = this.chart.getSelection();
                });

            }, 50)

        },
        loadData(regionalData, districtualData) {
            let chartData = [
                [
                    "Location",
                    "Parent",
                    "Strata Score (size)",
                    "Strata Score(color)",
                ],
            ];

            let locations = [];
            let parents = [];
            let sizes = [];
            let colours = [];

            let regionalDataFeatures = regionalData.datasets[0].data.features;
            let districtualDataFeatures = districtualData.datasets[0].data.features;

            let indicatorKeys = getIndicatorKeys(districtualData.datasets[0].data);
            let indicatorNames = getIndicatorNames(indicatorKeys);

            regionalDataFeatures.forEach((feature) => {
                let featureProperties = feature.properties;
                // region parent will be the country of origin
                let regionParent = featureProperties.ADM0_NAME;
                // check if parent has been added to data, if not add it
                if (!locations.includes(regionParent)) {
                    locations.push(regionParent);
                    parents.push(null);
                    sizes.push(0);
                    colours.push(0);
                }
                // add regions data
                let regionName = featureProperties.ADM1_NAME;
                if (regionName == 'Administrative unit not available'){
                    console.info('Unknown region: ', regionName);
                }
                locations.push(regionName);
                parents.push(regionParent);
                sizes.push(featureProperties.region_value);
                colours.push(featureProperties.region_value);
            });

            let unknownAdminUnit = 0;
            districtualDataFeatures.forEach((feature) => {
                let featureProperties = feature.properties;
                let districtParent = featureProperties.ADM1_NAME;
                let districtName = featureProperties.ADM2_NAME;

                // some regions and districts have the same name and region
                // for example Banadir is both a region and district
                // therefore we can assume it only needs to be shown once
                // TODO - verify this is wanted behaviour
                if (featureProperties.ADM2_NAME !== districtParent) {
                    // check for unknown admin unit
                    if (districtName == 'Administrative unit not available'){
                        districtName = `Unknown admin unit (${unknownAdminUnit})`;
                        unknownAdminUnit++;
                    }
                    // check for duplicate region and district names
                    if (locations.includes(districtName)) {
                        districtName = `${districtName} (District)`;
                    }
                    locations.push(districtName);
                    parents.push(districtParent);
                    sizes.push(featureProperties.region_value);
                    colours.push(featureProperties.region_value);
                }

                indicatorKeys.forEach((indicatorkey, index) => {
                    locations.push(districtName + " " + indicatorNames[index]);
                    parents.push(districtName);
                    sizes.push(featureProperties[indicatorkey]);
                    colours.push(featureProperties[indicatorkey]);
                });
            });

            let nData = locations.length;
            for (let i = 0; i < nData; i++) {
                chartData.push([
                    locations[i],
                    parents[i],
                    sizes[i],
                    colours[i],
                ]);
            }

            // console.table(chartData);

            return chartData;
        },
        rollupTreeChart() {
            this.chart.goUpAndDraw();
            this.selection = this.chart.getSelection();
         }
    },
};
</script>
<style scoped>
.back-btn {
    position: absolute;
    right: 22px;
    top: 15px;
}
</style>